// extracted by css-extract-rspack-plugin
export default {"reportCard":"reportCard-l7TqCy","reportTitle":"reportTitle-I_stuz","reportDetail":"reportDetail-iE__h1"};